import styled from "styled-components"
import { Form } from "../Form"
import { Button } from "../Button"
import { device } from "utils/breakpoints.js"
import { GradientButton } from "components/ProjectStyles"
import { getGradientText } from "helpers/getGradientText"
import { getSolidColor } from "../../utils/helpers/getSolidColor"

export const SubmitButton = styled(GradientButton)`
  width: 100%;
  font-size: 16px;
  height: 50px;

  @media ${device.desktop} {
    height: 60px;
    font-size: 20px;
    width: 220px;
    float: right;
  }
`

export const CustomForm = styled(Form)`
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #d2d4e0;
  /* padding-top: 30px; */
  max-width: 100%;
  @media ${device.desktop} {
    width: 100%;
    margin: 0;
    padding-top: 30px;
    padding-right: 55px;
    padding-bottom: 0;
    border-bottom: none;
    /* margin-bottom: 120px; */
  }

  > * {
    display: ${props => props.submitted && "none"};
  }
`

export const Request = styled.p`
  font-size: 20px;
  margin-bottom: 15px;
  display: block !important;
  line-height: 27px;
  ${props => getGradientText(props.theme.site)};

  @media ${device.desktop} {
    font-size: 28px;
    margin-bottom: 20px;
    line-height: 150%;
  }
`

export const SubText = styled.p`
  font-size: 16px;
  margin-bottom: 25px;
  display: block !important;
  @media ${device.desktop} {
    font-size: 20px;
    margin-bottom: 55px;

    margin-bottom: ${props => props.submitted && "40px"};
  }
  a {
    color: black;
    font-weight: 600;
    background-image: ${props =>
      `linear-gradient(to right, ${getSolidColor(
        props.theme.site
      )}, ${getSolidColor(props.theme.site)})`};
    background-position: 0 100%;
    background-repeat: no-repeat;
    background-size: 100% 1px;

    @media ${device.desktop} {
      background-position: 0 97%;
    }

    :hover {
      background-size: 100% 0px;
    }
  }
`

export const SuccessMessage = styled(Request)`
  color: #434345;
  display: ${props => (props.submitted ? "block" : "none")} !important;

  @media ${device.desktop} {
    font-size: 20px;
    margin-bottom: 40px;
  }
`
export const BackToHome = styled(SubmitButton)`
  width: auto;
  display: ${props => (props.submitted ? "inline-flex" : "none")} !important;
  margin-top: 10px;

  @media ${device.desktop} {
    width: 260px;
    float: left;
  }
`
